import { useCallback } from 'react';
import DeviceInfo from '../../../DeviceInfo';
import { isIOS } from '../../../isIOS';
import { isNotNil } from '../../../isNotNil';
import { useOpenDeeplink } from '../../../../hooks';
import { appendParams, finalizeUrl, getDefaultWebviewLink } from '../../utils';

const getPath = (path: keyof typeof WEBVIEW_PAGE | string) => {
  if (isNotNil(WEBVIEW_PAGE[path as keyof typeof WEBVIEW_PAGE])) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return WEBVIEW_PAGE[path];
  }
  return path;
};

export const useMoveToWebview = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    async (
      path: keyof typeof WEBVIEW_PAGE | string,
      { titleBar = false }: MoveToWebviewOptions = {},
    ) => {
      const webviewPath = getPath(path);
      const url = getDefaultWebviewLink(titleBar);

      if ((await DeviceInfo.getVersion()) === '2.334.0' && isIOS) {
        appendParams(url, 'url', `https://m.a-bly.com${webviewPath}`);
        openDeeplink(finalizeUrl(url));
        return;
      }
      appendParams(url, 'url', `${webviewPath}`);
      openDeeplink(finalizeUrl(url));
    },
    [openDeeplink],
  );
};

type MoveToWebviewOptions = {
  titleBar?: boolean;
};

const WEBVIEW_PAGE = {
  /** - 장바구니로 이동 */
  Cart: '/cart?from=CARTICON',
  /** - AI 옷입히기 생성 페이지로 이동 */
  CreateOutfitTryOn:
    '/content/fitting-rooms/outfit-try-on/create?conceptId%3D1%26categoryChipKey%3DrecentlyViewed%26entryPoint%3DRECENTLY_VIEWED_GOOD',
  /** - 뷰티관으로 이동  */
  BeautyDepartment: '/screens/?screen_name=BEAUTY_DEPARTMENT',
  /** - 이용약관 */
  TermsOfUse: '/agreement/terms-of-use',
  /** - 개인정보 처리방침 */
  Privacy: '/agreement/privacy',
  /** - 청소년 보호정책 */
  YouthPolicy: '/youth-policy',
} satisfies Record<string, `/${string}`>;
